import script from "./QrReservaServicios.vue?vue&type=script&setup=true&lang=js"
export * from "./QrReservaServicios.vue?vue&type=script&setup=true&lang=js"

import "./QrReservaServicios.vue?vue&type=style&index=0&id=66d8ff52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66d8ff52"]])

export default __exports__